export function getManualBundlePrice(checks, manualBundleProducts) {
  let finalPrice = 0;
  let finalTashleelAmount = 0;
  let finalTashleelCashbackAmount = 0;
  let finalCashBackPrice = 0;

  checks.map(val => {
    if (manualBundleProducts?.length) {
      manualBundleProducts[0].bundleProducts.map(bundle => {
        if (val === bundle.code) {
          if (bundle.discountPrice) {
            finalPrice = finalPrice + bundle.discountPrice.value;
          } else {
            finalPrice = finalPrice + bundle.price.value;
          }

          if (bundle.tasheelPriceValuesList && bundle.tasheelPriceValuesList.length > 0) {
            finalTashleelAmount = finalTashleelAmount + bundle.tasheelPriceValuesList[0].priceValueTasheel.value;
          }

          if (bundle.tasheelCashBackPriceValuesList && bundle.tasheelCashBackPriceValuesList.length > 0) {
            finalTashleelCashbackAmount =
              finalTashleelCashbackAmount +
              Number(bundle.tasheelCashBackPriceValuesList[0].priceValueTasheel.formattedValue);
          } else if (bundle.tasheelPriceValuesList && bundle.tasheelPriceValuesList.length > 0) {
            finalTashleelCashbackAmount =
              finalTashleelCashbackAmount + bundle.tasheelPriceValuesList[0].priceValueTasheel.value;
          }
          if (bundle.cashBackPrice) {
            finalCashBackPrice = finalCashBackPrice + bundle.cashBackPrice;
          }
        }
      });
    }
  });

  return {
    finalPrice: finalPrice,
    finalTashleelAmount: finalTashleelAmount,
    finalTashleelCashbackAmount: finalTashleelCashbackAmount,
    finalCashBackPrice: finalCashBackPrice,
  };
}
